import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import TeamMembersList from "../teams/components/TeamMembersList";
import type { TeamMember } from "../teams/types";
import styles from "../teams/components/TeamSettings.module.css";
import { MoveLeft, Plus } from "lucide-react";

const DEMO_JOIN_CODE = "DEMO-7X2K";

const HARDCODED_TEAMS = ["Engineering", "Transport", "Business", "Support"];

const HARDCODED_TEAM_MEMBERS = [
  { id: "demo-m0", email: "alice@acme.demo", status: "active", uid: "demo-m0" },
  { id: "demo-m1", email: "bob@acme.demo", status: "active", uid: "demo-m1" },
  { id: "demo-m2", email: "carol@acme.demo", status: "active", uid: "demo-m2" },
];

function teamSlug(label: string) {
  return label.toLowerCase().replace(/\s+/g, "-");
}

const hardcodedTeamUsers = HARDCODED_TEAMS.map((name, i) => ({
  id: `hardcoded-${i}`,
  email: name,
  status: "active",
  uid: `hardcoded-${i}`,
}));

const DemoTeamInvite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isTeamsList = location.pathname === "/app/settings/teams";
  const pageTitle = isTeamsList ? "TeamsOverview" : "TeamsOverview members";
  const demoUsers = isTeamsList ? hardcodedTeamUsers : HARDCODED_TEAM_MEMBERS;

  return (
    <>
      <div className="settings-element-header">
        <MoveLeft
          onClick={() => navigate("/app/settings")}
          className={styles["back-button"]}
        />

        <p className={`settings-element-title page-title`}>{pageTitle}</p>

        <div></div>
        <Plus className={styles["hidden-plus-button"]} />
      </div>

      <div style={{ marginLeft: "16px", marginRight: "16px" }}>
        <h4>Users can join with code: {DEMO_JOIN_CODE}</h4>

        <TeamMembersList
          demoUsers={demoUsers}
          onRowClick={
            isTeamsList
              ? (user: TeamMember) =>
                  navigate(
                    `/app/settings/teams/team-overview/${teamSlug(user.email)}`
                  )
              : undefined
          }
        />
      </div>

      <button
        className="proceed-button"
        onClick={() => navigate("/app/demo-team")}
      >
        Go to team insights
      </button>
    </>
  );
};

export default DemoTeamInvite;
